import GuestEmails from "./GuestEmails";
import * as campaignActions from "../../../../../../actions/campaignAction";
import { connect } from 'react-redux';

const mapStateToProps = state => {
    return {
        campaignState: state.campaignReducer,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        parseExcel: (file) => dispatch(campaignActions.parseExcel(file)),
        parseExcelClearData: () => dispatch(campaignActions.parseExcelClearData()),
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(GuestEmails);
